export default "__VITE_ASSET__t91bC4KT__"